import * as MySuccessApi from 'api/mySuccess';
import { DATA_BAG } from 'defs/offlineAvailability';
import Sequences from 'defs/sequences';
import { call, put, select } from 'redux-saga/effects';
import { actionCreators as connectionAC, getIsOnline } from 'store/connection';
import { getIsMigrosAuthenticated } from 'store/login';
import { actionCreators as mySuccessAC } from 'store/mySuccess';
import { actionCreators as offlineAvailabilityAC } from 'store/offlineAvailability';
import { getIsAnamnesisDone } from 'store/profile';
import { actionCreators as sequenceAC } from 'store/sequences';

export function* loadHallOfFame() {
	const isOnline = yield select(getIsOnline);
	if (!isOnline) {
		return yield put(connectionAC.doTrackNetworkFetchRequestError());
	}

	const isAnamnesisDone = yield select(getIsAnamnesisDone);
	if (!isAnamnesisDone) {
		return void 0;
	}

	const isMigrosAuthenticated = yield select(getIsMigrosAuthenticated);
	if (!isMigrosAuthenticated) {
		return false;
	}

	yield put(sequenceAC.doStartSequence(Sequences.LOAD_MY_SUCCESS_HALL_OF_FAME));
	yield put(mySuccessAC.doRequestMySuccessLoading());
	try {
		const hallOfFame = yield call(MySuccessApi.fetchHallOfFame);

		yield put(mySuccessAC.doRequestMySuccessSuccess(hallOfFame));
		yield put(offlineAvailabilityAC.doRegisterDataBag(DATA_BAG.MY_SUCCESS));
	} catch (err) {
		// do nothing
	}

	yield put(sequenceAC.doFinishSequence(Sequences.LOAD_MY_SUCCESS_HALL_OF_FAME));
}

export function* loadLevels() {
	const isOnline = yield select(getIsOnline);
	if (!isOnline) {
		return yield put(connectionAC.doTrackNetworkFetchRequestError());
	}

	const isAnamnesisDone = yield select(getIsAnamnesisDone);
	if (!isAnamnesisDone) {
		return;
	}

	const isMigrosAuthenticated = yield select(getIsMigrosAuthenticated);
	if (!isMigrosAuthenticated) {
		return false;
	}

	try {
		const allLevels = yield call(MySuccessApi.fetchAllLevels);

		yield put(mySuccessAC.doRequestMySuccessLevelsSuccess(allLevels));
		yield put(offlineAvailabilityAC.doRegisterDataBag(DATA_BAG.MY_SUCCESS_LEVELS));
	} catch (e) {
		// do nothing
	}
}
